<script>
  import { createEventDispatcher } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let active = false
  export let id = null

  const dispatch = createEventDispatcher()

  export const open = () => {
    active = true
  }
  export const close = () => {
    active = false
    dispatch('close')
  }
</script>

<div class={`${cssPrefix}toast`} class:is-open={active} {id}>
  <slot />
</div>
